import React from 'react'
import MessageList from '../../pages/clients/message/MessageList'
import ChatConversation from '../../pages/clients/message/ChatConversation'
import WelcomeMessage from '../../pages/clients/message/WelcomeMessage'

const DesktopMessaging = ({sidebarComponent,handleSelectChat,selectedChatId,
  handleProfileView}) => {
  return (
      <div className="h-screen flex bg-white dark:bg-[#0b0e14] font-['Poppins'] relative">
      {/* Sidebar - passed as prop */}
      {sidebarComponent}
      
      {/* Message List */}
      <div className="w-72 border-r dark:border-[#0b0e14] overflow-hidden">
        <MessageList 
          onSelectChat={handleSelectChat}
          selectedChatId={selectedChatId}
        />
      </div>
      
      {/* Chat Conversation or Welcome Message */}
      <div className="flex-1 overflow-hidden h-full">
        {selectedChatId ? (
          <ChatConversation 
            onProfileView={handleProfileView}
          />
        ) : (
          <WelcomeMessage />
        )}
      </div>
      
      
    </div>
  )
}

export default DesktopMessaging